module.exports = __webpack_public_path__ + "static/media/therapy-bg.f34af13c.svg";